module.exports = __webpack_public_path__ + "static/media/SupportaTroop_Logo_WhiteTxt.079414fc.png";